<script>
  let menuItems = [
    { label: "Cosa facciamo", anchor: "#whatwedo" },
    { label: "Le nostre iniziative", anchor: "#ouractions" },
    {
      label: "Area Riservata",
      anchor: "#reservedarea",
      children: [
        { label: "Agricoltura di precisione", anchor: "#wip1" },
        { label: "Aerospazio", anchor: "#wip2" },
        { label: "Economia Circolare", anchor: "#wip3" }
      ]
    },
    { label: "Team", anchor: "#team" }
  ];
</script>

<style>
  ul {
    margin: 0;
    padding: 0;
  }
  .menu-container {
    padding: 20px;
    border-bottom: solid 1px #d6d6d6;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .menu-container img {
    height: 80px;
  }

  .menu-list {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  .menu-item {
    margin: 10px;
    display: inline;
    position: relative;
  }

  .menu-list > .menu-item:after {
    transition: 250ms;
    content: "";
    width: 0px;
    height: 5px;
    background-color: var(--blue);
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    border-radius: 5px;
  }
  .menu-list > .menu-item:hover:after {
    width: 100%;
  }

  .menu-child-list {
    background: white;

    transition: 350ms;
    overflow: hidden;
    position: absolute;
    width: 200px;
    padding-top: 10px;
    top: -400px;
    right: 0;
    text-align: right;
    opacity: 0;
  }

  .menu-child-item a:before {
    width: 0px;
    transition: 250ms;
    content: "";
    height: 100%;
    display: block;
    background-color: var(--blue);
    position: absolute;
    right: 0px;
    top: 0;
    z-index: -1;
    border-radius: 50px;
  }

  .menu-child-item a:hover:before {
    width: 100%;
  }

  .menu-child-item a:hover {
    color: white;
    z-index: 999;
  }

  .menu-child-item {
    position: relative;
    padding: 5px 0px 5px 5px;
  }

  .menu-child-item a {
    position: relative;
    padding: 5px 10px;
  }

  .menu-item:hover .menu-child-list {
    top: auto;
    opacity: 1;
    overflow: auto;
    padding-top: 10px;
  }

  @media (max-width: 900px) {
    :global(.menu-container) {
      flex-direction: column;
      padding-top: 0px;
    }
  }
</style>

<div class="menu-container">
  <img src="static/images/logo.jpg" alt="" />
  <ul class="menu-list">
    {#each menuItems as menuItem}
      <li class="menu-item">
        <a href={menuItem.anchor}>{menuItem.label}</a>
        {#if menuItem.children}
          <ul class="menu-child-list">
            {#each menuItem.children as child}
              <li class="menu-child-item">
                <a href={child.anchor}>{child.label}</a>
              </li>
            {/each}
          </ul>
        {/if}
      </li>
    {/each}
  </ul>
</div>
